import { useState } from "react";
import { Card, Group, Text, ActionIcon, Badge } from "@mantine/core";
import { IconEdit, IconTrash, IconGripVertical } from "@tabler/icons-react";
import { useDeleteRegistrationCustomField } from "../../api/registrationCustomFields";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";
import EditCustomFieldModal from "./EditCustomFieldModal";

function CustomFieldCard({ fieldData, event, isDraggable = false }) {
  const [editModalOpened, setEditModalOpened] = useState(false);
  const { mutate } = useDeleteRegistrationCustomField(fieldData.id);
  const confirmDelete = useDeleteConfirm("custom field", mutate);

  return (
    <>
      <Card shadow="sm" p="md" radius="md" withBorder>
        <Group gap="sm" wrap="nowrap" align="center">
          {isDraggable && (
            <div
              style={{
                cursor: "grab",
                display: "flex",
                alignItems: "center",
                color: "#868e96",
              }}
            >
              <IconGripVertical size={18} />
            </div>
          )}

          <div style={{ flex: 1, minWidth: 0 }}>
            <Group gap="xs" wrap="wrap">
              <Text fw={600} size="sm" style={{ wordBreak: "break-word" }}>
                {fieldData.label}
              </Text>
              <Badge size="sm" color="green" variant="light">
                {fieldData.type}
              </Badge>
              {fieldData.required && (
                <Badge size="sm" color="red" variant="light">
                  Required
                </Badge>
              )}
              {!fieldData.showOnRegistrationForm && (
                <Badge size="sm" color="gray" variant="light">
                  Internal
                </Badge>
              )}
            </Group>
            <Group gap="xs" mt={4}>
              <Text size="xs" c="dimmed">
                Key: {fieldData.key}
              </Text>
              <Text size="xs" c="dimmed">
                •
              </Text>
              <Text size="xs" c="dimmed">
                Applied to: {fieldData.appliedTo}
              </Text>
            </Group>
            {(fieldData.type === "select" ||
              fieldData.type === "multiselect") &&
              fieldData.options?.length > 0 && (
                <Group gap={4} mt={6}>
                  {fieldData.options.slice(0, 3).map((opt, i) => (
                    <Badge key={i} size="xs" color="violet" variant="dot">
                      {opt}
                    </Badge>
                  ))}
                  {fieldData.options.length > 3 && (
                    <Badge size="xs" color="gray" variant="dot">
                      +{fieldData.options.length - 3} more
                    </Badge>
                  )}
                </Group>
              )}
          </div>

          <Group gap="xs" wrap="nowrap">
            <ActionIcon
              color="blue"
              onClick={() => setEditModalOpened(true)}
              variant="light"
              size="md"
            >
              <IconEdit size={20} />
            </ActionIcon>

            <ActionIcon
              color="red"
              onClick={() => confirmDelete()}
              variant="light"
              size="md"
            >
              <IconTrash size={20} />
            </ActionIcon>
          </Group>
        </Group>
      </Card>

      <EditCustomFieldModal
        opened={editModalOpened}
        onClose={() => setEditModalOpened(false)}
        fieldData={fieldData}
        event={event}
      />
    </>
  );
}

export default CustomFieldCard;
